import Api from '@/modules/core/api/api.ts';
import { CategoryAdapter } from '@/modules/counterparty/adapters/category.adapter.ts';
import { CategoryEndPoint } from '@/modules/counterparty/enums/counterparty-end-point.enum.ts';
import { RequestUtil } from '@/modules/core/utils/request.util.ts';
import { Direction } from '@/modules/common/enums/direction.enum.ts';
import type { ItemsDto } from '@/modules/common/dto/items.dto.ts';
import type { CategoryDto } from '@/modules/counterparty/dto/category.dto.ts';

export class CategoryApi {
  static async getList(signal: AbortSignal) {
    const response: ItemsDto<CategoryDto> = await Api.post(
      CategoryEndPoint.GetList,
      RequestUtil.orderBy('Приоритет', Direction.Asc),
      signal
    );
    return CategoryAdapter.mapList(response);
  }
}
